import { useState, useEffect } from 'react';
import { UI } from '../constants';

const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      // Considered 'mobile' if width is 768px or less
      setIsMobile(window.innerWidth <= UI.MOBILE_BREAKPOINT);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return isMobile;
};

export default useIsMobile;
